import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
import ProgressBar from '../progress-bar';
const StyledContainer = styled.View`
  background-color: ${Colors.advanceBlue10};
  border: 1px solid ${Colors.advanceBlue300};
  width: 100%;
  border-radius: 4px;
  padding: 16px;
`;
const StyledBodySmall = styled(Text.BodySmall)`
  line-height: 24px;
`;
export default function Progress(props) {
  const {
    footer
  } = props;
  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(StyledBodySmall, {
    weight: "bold",
    color: Colors.gray600
  }, props.title), /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    height: true
  }), /*#__PURE__*/React.createElement(ProgressBar, {
    progress: props.progress
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    type: "paragraph",
    color: Colors.gray500
  }, props.children), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), footer());
}
Progress.defaultProps = {
  progress: 0,
  title: '',
  footer: () => {},
  children: ''
};
Progress.propTypes = {
  progress: PropTypes.number,
  title: PropTypes.string,
  footer: PropTypes.func,
  children: PropTypes.string
};
//# sourceMappingURL=progress.js.map